import {useMemo} from 'react';
import {APP_ROUTES, APP_ROUTES_KEYS, APP_ROUTES_TO_URL} from '../../constants';
import {IQuery} from '../../types';

export const useEventsRoutes = () => {
    const routesFactory = () => {
        const baseUrl = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.events];
        const url = (query?: IQuery) => (query?.id ? `${baseUrl}/${query.id}` : baseUrl);
        const to = () => url();

        return {section: APP_ROUTES[APP_ROUTES_KEYS.events], to, url};
    };

    return useMemo(routesFactory, []);
};
